import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTASection() {
  return <Section id="comprar" className="bg-amber-600 text-white text-center py-20" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-15">
          Deja de sentirte atrás.
        </h2>
        <p className="text-xl md:text-2xl text-amber-100 mb-10 leading-relaxed" data-id="element-16">
          Si hoy estás cansado de improvisar, pero tampoco tienes tiempo para
          cursos eternos, esta guía es para ti.
        </p>

        <div className="bg-white/10 p-8 rounded-2xl backdrop-blur-sm border border-white/20 mb-10" data-id="element-17">
          <p className="text-lg font-medium mb-4" data-id="element-18">
            Compra "IA Sin Miedo (48 horas)"
          </p>
          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-19">
            <span className="text-2xl text-amber-200 line-through" data-id="element-20">$25.00</span>
            <span className="text-5xl font-bold text-white" data-id="element-21">$6.36</span>
          </div>
          <span className="inline-block bg-white/20 text-white text-sm font-bold px-3 py-1 rounded-full mb-3" data-id="element-22">
            Ahorra 75%
          </span>
          <p className="text-amber-100 text-sm" data-id="element-23">
            Y en dos días tendrás tus prompts y rutinas funcionando en tu
            negocio.
          </p>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-24">
          <a href="https://eficienciadigital.ca/" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} data-id="element-25">
            <Button size="lg" className="bg-white text-amber-700 hover:bg-amber-50 shadow-xl w-full sm:w-auto text-lg font-bold px-10 py-6 h-auto" data-id="element-26">
              Quiero mi guía (PDF) <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-27" />
            </Button>
          </a>

          <div className="flex items-center text-amber-200 text-sm mt-4" data-id="element-28">
            <LockIcon className="h-4 w-4 mr-2" data-id="element-29" />
            <span data-id="element-30">Pago seguro • Entrega inmediata por email</span>
          </div>
        </div>
      </div>
    </Section>;
}